// Bulle « Nous contacter » (snippets/zs-contact.liquid) : un toucher de la bulle ouvre le menu, « Écrire sur le chat » ouvre le chat Limova dans le
// panneau du thème. L'iframe du chat n'est créée qu'à la première ouverture : tant que le visiteur n'a pas choisi le chat, rien de Limova ne se charge.
(function () {
  var racine = document.querySelector('.zs-contact');
  if (!racine) return;
  var bulle = racine.querySelector('.zs-contact__bulle');
  var menu = racine.querySelector('.zs-contact__menu');
  var panneau = racine.querySelector('.zs-contact__panneau');
  var fermerChat = racine.querySelector('.zs-contact__fermer');
  var cadre = null;

  // etat : 'ferme', 'menu' ou 'chat'
  function montrer(etat) {
    menu.hidden = etat !== 'menu';
    panneau.hidden = etat !== 'chat';
    racine.classList.toggle('zs-contact--ouvert', etat !== 'ferme');
    bulle.setAttribute('aria-expanded', etat === 'ferme' ? 'false' : 'true');
    if (etat === 'chat' && !cadre) {
      cadre = document.createElement('iframe');
      cadre.className = 'zs-contact__cadre';
      cadre.title = racine.getAttribute('data-titre') || '';
      cadre.setAttribute('allow', 'web-share; clipboard-write');
      cadre.addEventListener('load', function () { panneau.classList.add('zs-contact__panneau--pret'); });
      cadre.src = racine.getAttribute('data-chat');
      panneau.appendChild(cadre);
    }
  }

  function ouvert() { return racine.classList.contains('zs-contact--ouvert'); }

  bulle.addEventListener('click', function () { montrer(ouvert() ? 'ferme' : 'menu'); });

  racine.querySelector('[data-zs-chat]').addEventListener('click', function () {
    montrer('chat');
    fermerChat.focus();
  });

  fermerChat.addEventListener('click', function () {
    montrer('ferme');
    bulle.focus();
  });

  // WhatsApp et l'appel quittent la page : le menu se referme
  menu.addEventListener('click', function (e) {
    if (e.target.closest('a')) montrer('ferme');
  });

  // Un toucher ailleurs referme le menu ; le chat, lui, reste ouvert pendant qu'on lit la page
  document.addEventListener('pointerdown', function (e) {
    if (!menu.hidden && !racine.contains(e.target)) montrer('ferme');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ouvert()) {
      montrer('ferme');
      bulle.focus();
    }
  });
})();

// Mesure des contacts : un clic sur un lien WhatsApp, sur un lien téléphone ou sur « Écrire sur le chat » (bulle, en-tête, pied de page, page
// partenaires) publie l'événement zs:contact, avec le canal (whatsapp, appel, chat) et l'emplacement (bulle, entete, pied, page). Le thème n'envoie rien
// lui-même : c'est le pixel personnalisé « ZenSpire contacts » (Paramètres, Événements clients) qui reçoit l'événement, et seulement si le visiteur a accepté
// les cookies d'analyse.
(function () {
  function canal(cible) {
    if (cible.closest('[data-zs-chat]')) return 'chat';
    var lien = cible.closest('a[href]');
    if (!lien) return null;
    var href = lien.getAttribute('href') || '';
    if (/^tel:/i.test(href)) return 'appel';
    if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href)) return 'whatsapp';
    return null;
  }

  function emplacement(cible) {
    if (cible.closest('.zs-contact')) return 'bulle';
    if (cible.closest('header')) return 'entete';
    if (cible.closest('footer')) return 'pied';
    return 'page';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var c = canal(e.target);
    if (!c || !window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return;
    try {
      window.Shopify.analytics.publish('zs:contact', { canal: c, emplacement: emplacement(e.target) });
    } catch (erreur) { /* la mesure ne doit jamais gêner le contact */ }
  });
})();
